import { Subscription } from 'rxjs';
export class AdvisorModel {
  uid: string;
  name: string;
  vatNumber: string;
  provinceCode: string;
  municipalityCode: string;
  active: boolean;
  partners: Partner[]
  constructor() {

    this.uid = null;
    this.name = '';
    this.vatNumber = '';
    this.provinceCode = '';
    this.municipalityCode = '';
    this.active = true;
    this.partners=[]
  }
}
export interface Partner{
  Username: string;
  IsActivated:boolean;
  IsSubscribed:boolean;
  Datetime:Date;
  SubscriptionEndDate:Date;
  Subscription: string;
  Price:number;

}

export interface AssignAdvisor {
  advisorUid: string;
  userUid: string;
}